﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyGeolocationPermissionRequest", [
    "PageOptions",
    "LocationManager",
    function (PageOptions, LocationManager) {
      var controller = [
        "$scope",
        "$rootScope",
        "$attrs",
        "$window",
        "Location",
        "ModalService",
        "DealerSelector",
        function ($scope, $rootScope, $attrs, $window, Location, ModalService, DealerSelector) {
          var reloadOnDealerLocationChange = false;

          $scope.fetchDealers = function (postcode, suburb) {
            var dealers = [];
            LocationManager.triggerDidLocationChangeDealersLoadBegin();

            LocationManager.fetchDealers(postcode, suburb)
              .then(function (response) {
                dealers = response;
              })
              .finally(function () {
                var firstDealer = dealers[0];
                LocationManager.setDefaultDealerAndResetSavedDealer(firstDealer);

                LocationManager.triggerDidLocationChangeDealersLoadEnd();

                if (reloadOnDealerLocationChange && !ModalService.isModalOpen("change-location")) {
                  $window.location.reload();
                }
              });
          };

          $scope.onCurrentLocation = function () {
            return LocationManager.getCurrentLocation($attrs.errorMessageInvalidCountryToast).then(
              function (response) {
                Location.update(
                  response.postcode,
                  response.suburb,
                  response.state,
                  response.region,
                  response.pricingZone,
                  "geo-location"
                );
                $scope.fetchDealers(response.postcode, response.suburb);
              },
              function () {
                /*
                 * Created tech debt to address this
                 * https://toyotaau.atlassian.net/browse/SIR-4580
                 */
              }
            );
          };

          $scope.init = function () {
            reloadOnDealerLocationChange = JSON.parse($attrs.reloadPageOnDealerLocationChange);
            PageOptions.setReloadOnDealerLocationChange(reloadOnDealerLocationChange);
            $scope.$on("GeoPostCode", function (event, postcode) {
              $scope.geoPostCode = postcode;
            });

            var location = LocationManager.getLocationObject();

            if (location.postcode === "") {
              $scope.onCurrentLocation();
            }
          };

          // If TRIM dealer selector is disabled, we must do our own geolocation
          if (DealerSelector.getIsUsingLegacy()) {
            $scope.init();
          }
        },
      ];

      return {
        scope: true,
        restrict: "E",
        controller: controller,
        bindToController: true,
      };
    },
  ]);
})(window.angular);
